import { render } from "./floatingMenu.vue?vue&type=template&id=822bae86&scoped=true"
import script from "./floatingMenu.vue?vue&type=script&lang=js"
export * from "./floatingMenu.vue?vue&type=script&lang=js"

import "./floatingMenu.vue?vue&type=style&index=0&id=822bae86&lang=scss&scoped=true"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-822bae86"]])

export default __exports__